module.exports = (__webpack_require__(47266))(3842);